import Image from 'next/image';
import Badge from '@/common/Badge';
import Text from '@/components/Text';
import CountdownTimer from '@/components/CountdownTimer';
import DateTimeUtils from '@/utils/DateTimeUtils';
import TournamentsUtils from '@/utils/TournamentsUtils';
import { Tournament } from '@/lib/Tournaments/types';

interface ITournamentsTimeBadgeProps {
  tournament: Tournament;
  icon?: React.ReactNode;
}

function TournamentsTimeBadge({ tournament, icon }: ITournamentsTimeBadgeProps) {
  return (
    <Badge variant="default" icon={icon ? icon : <Image src="/icons/time-clock.png" width={21} height={21} alt={TournamentsUtils.TOURNAMENT_STATUS_BADGE[tournament.status]}/>}>
      <Text size="xs">
        {tournament.status === 'InProgress' && (
          <>
            Ends in{' '}
            <CountdownTimer
              showSeconds={false}
              abbreviatedSuffix={true}
              targetDate={tournament.endDate}
              expiredMessage=""
            />
          </>
        )}
        {tournament.status === 'Open' && (
          <>
            Starts in{' '}
            <CountdownTimer
              showSeconds={false}
              abbreviatedSuffix={true}
              targetDate={tournament.startDate}
              expiredMessage=""
            /> 
          </>
        )}
        {tournament.status === 'Finished' && (
          <>{DateTimeUtils.formatDate(tournament.endDate, "MMM Do")}</>
        )}
        {tournament.status === 'Cancelled' && (
          <>Cancelled on {DateTimeUtils.formatDate(tournament.startDate, "MMM Do")}</>
        )}
      </Text>
    </Badge>
  );
}

export default TournamentsTimeBadge;
